module.exports = __webpack_public_path__ + "img/img-zhilian-s5-tuya.b2a5188d.jpg";